import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=74c5caab&scoped=true"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"
import style0 from "./Email.vue?vue&type=style&index=0&id=74c5caab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5caab",
  null
  
)

export default component.exports